import { render, staticRenderFns } from "./SubmitSuccess.vue?vue&type=template&id=de455454&scoped=true&"
import script from "./SubmitSuccess.vue?vue&type=script&lang=js&"
export * from "./SubmitSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SubmitSuccess.vue?vue&type=style&index=0&id=de455454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de455454",
  null
  
)

export default component.exports